import {Container, Graphics, Text} from 'pixi.js';
import {gsap} from 'gsap';
import {avatarDisc} from './Impact';

/**
 * Full-screen moments: the catch celebration (the winner's avatar, big) and
 * the end-of-game podium. Both are 800×600 overlays the Game shows on the
 * stage and removes when their time is up.
 */

const MONO = 'Courier New, monospace';

function dim() {
  return new Graphics().rect(0, 0, 800, 600).fill({color: 0x000000, alpha: 0.62});
}

function bigText(text, size, y, color = 0xffffff) {
  const t = new Text({
    text,
    style: {fontFamily: MONO, fontSize: size, fontWeight: '700', fill: color, align: 'center'}
  });
  t.anchor.set(0.5);
  t.position.set(400, y);
  return t;
}

/** The catch moment — held for a few seconds after the dog's retrieve. */
export function makeCelebration({texture, handle, cell, catches, round}) {
  const overlay = new Container();
  overlay.addChild(dim());

  overlay.addChild(bigText('DUCK DOWN!', 46, 84, 0xffc73b));

  const disc = avatarDisc(texture, handle, 90);
  disc.position.set(400, 248);
  disc.addChild(new Graphics().circle(0, 0, 94).stroke({width: 7, color: 0xffc73b}));
  overlay.addChild(disc);

  overlay.addChild(bigText('@' + handle, 40, 390));
  overlay.addChild(bigText(catches === 1 ? 'first duck of the game' : catches + ' ducks this game', 18, 438, 0xbbbbbf));

  disc.scale.set(0.3);
  gsap.to(disc.scale, {x: 1, y: 1, duration: 0.5, ease: 'back.out(2)'});
  return overlay;
}

/** End-of-game podium: top hunters, biggest first. entries = [{handle, texture, catches}] */
export function makePodium(entries) {
  const overlay = new Container();
  overlay.addChild(dim());
  overlay.addChild(bigText('GAME OVER', 44, 96));
  overlay.addChild(bigText('top hunters', 20, 140, 0xbbbbbf));

  if (!entries.length) {
    overlay.addChild(bigText('the duck won this time — nobody zapped it', 22, 300, 0xffe08a));
    return overlay;
  }

  const slots = [
    {x: 400, y: 300, r: 74, medal: '1st', color: 0xffc73b},
    {x: 190, y: 330, r: 54, medal: '2nd', color: 0xc9ccd4},
    {x: 610, y: 330, r: 54, medal: '3rd', color: 0xcd8f52}
  ];
  entries.slice(0, 3).forEach((entry, i) => {
    const slot = slots[i];
    const disc = avatarDisc(entry.texture, entry.handle, slot.r);
    disc.position.set(slot.x, slot.y);
    disc.addChild(new Graphics().circle(0, 0, slot.r + 4).stroke({width: 6, color: slot.color}));
    overlay.addChild(disc);

    const medal = bigText(slot.medal, 22, 0, slot.color);
    medal.position.set(slot.x, slot.y - slot.r - 26);
    overlay.addChild(medal);

    const who = bigText('@' + entry.handle, 19, 0);
    who.position.set(slot.x, slot.y + slot.r + 22);
    overlay.addChild(who);

    const count = bigText(entry.catches + (entry.catches === 1 ? ' duck' : ' ducks'), 15, 0, 0xbbbbbf);
    count.position.set(slot.x, slot.y + slot.r + 48);
    overlay.addChild(count);
  });

  overlay.addChild(bigText('back to the menu in a moment — tap to skip', 17, 545, 0xbbbbbf));
  return overlay;
}
